<template>
  <el-select
    v-model="localValue"
    filterable
    clearable
    :disabled="isDis"
    placeholder="请选择"
  >
    <el-option
      v-for="(item, index) in list"
      :key="index"
      :value="item.userId.toString()"
      :label="type==='OfflineBrigade'?item.nickName+'-'+item.phonenumber?item.phonenumber:'':type==='Repair'?item.nickName+' '+item.distance+'公里':item.nickName"
    >
      <el-tooltip
        placement="top"
        :enterable="false"
        :open-delay="300"
      >
        <p
          slot="content"
          style="max-width: 800px;white-space:pre-wrap;"
        >
          {{
            type === 'OfflineBrigade' ? item.nickName + '-' + item.phonenumber ? item.phonenumber : '' : type === 'Repair' ? item.nickName + ' ' + '\n' + ' 地址:' + JSON.parse(item.remark).address + '\n' + ' 距离' + item.distance + '公里' : item.nickName
          }}
        </p>
        <div style="max-width: 800px">
          {{
            type === 'OfflineBrigade' ? item.nickName + '-' + item.phonenumber ? item.phonenumber : '' : type === 'Repair' ? item.nickName + ' ' + item.distance + '公里' : item.nickName
          }}
        </div>
      </el-tooltip>
    </el-option>
  </el-select>
</template>

<script>
import {allUserByRoleIds} from "@/api/accident/edit";

export default {
  name: 'DictSelect',
  inject: {
    accident: {
      default: () => {
      }
    }
  },
  props: {
    type: {type: String, required: true},
    value: {
      type: [Number, String],
      default: () => ''
    },
    accident: {
      type: Object,
      default: () => {
      }
    },
    isDis: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      localValue: this.value?.toString() ?? null,
      list: []
    };
  },
  computed: {
    selecaData() {
      return this.$store.getters.selecaData;
    }
  },
  watch: {
    value(v) {
      if (this.v?.toString() !== this.localValue) {
        this.localValue = v?.toString();
      }
    },
    localValue(v) {
      this.$emit('input', v);
    },
    selecaData: {
      handler(val) {
        if (val && val.length) {
          this.list = this.filterList(val);
        }
      },
      immediate: true,
      deep: true
    },
    type: {
      handler(val) {
        if (val === 'OfflineBrigade') {
          allUserByRoleIds({roleIds: '111'}).then(res => {
            console.log(res);
            this.list = res.data.map(el => {
              return el.user
            })
          })
        }
        if (val === 'Repair') {
          allUserByRoleIds({roleIds: '109'}).then(res => {
            let repairList = []
            setTimeout(() => {
              repairList = res.data.map(el => {
                if (el.user && el.user.latitude && el.user.longitude && this.accident.latitude && this.accident.longitude) {
                  el.user['distance'] = this.GetDistance(this.accident.latitude, this.accident.longitude, el.user.latitude, el.user.longitude)
                }
                return el.user
              }).filter(el => {
                return el.latitude && el.longitude
              })
              this.list = repairList.sort((a, b) => {
                return a.distance - b.distance
              })
              // console.log(this.list);
            }, 1500);
          })
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 根据type获取具体列表
    filterList(data) {
      if (this.type === 'Repair') {
        return
      }
      let list = data.filter(el => {
        const arr = el.roles && el.roles.filter(role => {
          return role.roleKey === this.type;
        });
        return arr && arr.length;
      });
      if (this.type === 'Insurance' && list.length) {
        list.map((el, index) => {
          // 五个公司放在最前面
          if (el.nickName === '中国人寿财产保险股份有限公司' ||
            el.nickName === '中国平安财产保险股份有限公司' ||
            el.nickName === '中国太平洋财产保险股份有限公司' ||
            el.nickName === '中国人民财产保险股份有限公司' ||
            el.nickName === '紫金财产保险股份有限公司'
          ) {
            // console.log(index);
            list.splice(index, 1);
            list.unshift(el);
          }
        });
      }
      return list;
    },
    //计算距离，参数分别为第一点的纬度，经度；第二点的纬度，经度
    GetDistance(lat1, lng1, lat2, lng2) {
      function Rad(d) {
        return d * Math.PI / 180.0;//经纬度转换成三角函数中度分表形式。
      }

      var radLat1 = Rad(lat1);
      var radLat2 = Rad(lat2);
      var a = radLat1 - radLat2;
      var b = Rad(lng1) - Rad(lng2);
      var s = 2 * Math.asin(Math.sqrt(Math.pow(Math.sin(a / 2), 2) +
        Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)));
      s = s * 6378.137;// EARTH_RADIUS;
      s = Math.round(s * 10000) / 10000; //输出为公里
      //s=s.toFixed(4);
      // console.log(s+'公里');
      return s;
    }
  }
};
</script>

<style>

</style>
